/**
 * Import Dependency
 */
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import * as basketActions from '../../actions/components/basket'

/**
 * Import Component
 */
import WechatPayConfirmation from 'components/scenes/WechatPayConfirmation'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
  }
}
const mapDispatchToProps = (dispatch) => {
  const { submitDineinPayment} = bindActionCreators(basketActions, dispatch)
  return {
    submitDineinPayment,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(WechatPayConfirmation)))



// WEBPACK FOOTER //
// ./src/containers/scenes/WechatPayConfirmation.js